import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ImportApia } from 'services/API/Exploitation';
import ImportModalWithGroundType from './ImportModalWithGroundType';

const ImportModalApia = (props) => {
  const { i18n } = useTranslation();
  const config = useMemo(() => ({
    accept: '.zip',
    titleKey: 'title.apiaParcelImport',
    loadingKey: 'IMPORT_APIA_LOADING',
    errorKey: 'ERR_IMPORT_APIA',
    apiCall: (formData, exploitationId) =>
      ImportApia(i18n.language, formData, exploitationId),
  }), [i18n.language]);

  return <ImportModalWithGroundType config={config} {...props} />;
};

export default ImportModalApia;
